import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tuyrotupac',
  templateUrl: './tuyrotupac.component.html',
  styleUrls: ['./tuyrotupac.component.css']
})
export class TuyrotupacComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
